<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/accident'}">事故快报</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
                     style="width:60%;margin:0 auto">
                <el-form-item label="名称" prop="name">
                    <el-input size="small" v-model="ruleForm.name" style="width:500px"></el-input>
                </el-form-item>

                <el-form-item label="事故部门" prop="region">
                    <el-select size="small" v-model="ruleForm.depId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in depData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="发生地点" prop="region">
                    <el-input size="small" v-model="ruleForm.place" style="width:500px"></el-input>
                </el-form-item>

                <el-form-item label="事故原因" prop="region">
                    <el-select size="small" v-model="ruleForm.accidentReason" filterable placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="事故描述" prop="region">
                    <mavon-editor v-model="ruleForm.contentHtml" :subfield="false"/>
                </el-form-item>

                <el-form-item label="事故原因分析" prop="region">
                    <el-input size="small" v-model="ruleForm.analysis" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="发生时间" prop="region">
                    <el-date-picker size="small"
                                    v-model="ruleForm.occurTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="上报人" prop="region">
                    <el-select size="small" v-model="ruleForm.reporterId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in userData"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="附件" prop="region">
                    <el-upload
                            class="upload-demo"
                            drag
                            :on-change="handleChange"
                            :file-list="fileList"
                            :on-remove="handleRemove"
                            action="/v1/accidentBulletin/uploadTrainStuffFile"
                            multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-button size="small" type="primary" class="addBtn" @click="submitForm()">确定</el-button>
        </div>

    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        data() {
            return {
                userData: [],
                depData: [],
                reason: [],
                ruleForm: {
                    name: "",
                    content: "",
                    value: "",
                },
                options: [
                    {
                        value: 0,
                        label: "人的不安全行为",
                    },
                    {
                        value: 1,
                        label: "物的不安全行为",
                    },
                    {
                        value: 2,
                        label: "管理上的缺陷",
                    }


                ],
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                },
                fileList: [],
                getObj: {},
                isAdd: true,
            };
        },
        mounted: function () {
            this.getAllEmpInfo();
            this.getUserData();
        },
        methods: {
            getUserData() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.userData = res.body.data;
                    });
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },

            // 上传列表文件移除的事件
            handleRemove(file, fileList) {
                let arr = this.fileList
                for (let i in arr) {
                    if (arr[i].fileName === file.fileName) {
                        arr.splice(i, 1)
                    }
                }
                this.fileList = arr
            },
            //获取部门 信息
            getAllEmpInfo() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllEmplotee)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.depData = res.body.data;
                    });
            },
            submitForm() {
                let url = "";
                if (this.isAdd) {
                    url = "/accidentBulletin/save";
                } else {
                    url = "/accidentBulletin/update";
                }
                // if (this.fileList.length>0){
                let fileArray = [];
                for (let item in this.fileList) {
                    let fileInfo = {};
                    fileInfo.fileName = this.fileList[item].name;
                    fileInfo.url = this.fileList[item].response.data;
                    fileArray.push(fileInfo);
                }
                this.ruleForm.trainStuffDto = fileArray;
                // }
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then((res) => {
                        this.$message({
                            showClose: true,
                            message: "操作成功",
                            type: "success",
                        });

                        this.$router.push({
                            path: "/processManager/accident",
                        });
                    });
            },
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.isAdd = false;
                this.ruleForm = obj;
                if (obj.trainStuff != null) {
                    let files = JSON.parse(obj.trainStuff);
                    for (var i = 0; i < files.length; i++) {
                        let file = {response: {}};
                        file.response.data = files[i].url;
                        file.name = files[i].fileName;
                        this.fileList.push(file);
                    }

                }
            } else {
                this.ruleForm = {};
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
